import { observer } from 'mobx-react';
import moment from 'moment';
import { useContext, useMemo } from 'react';
import { Card, ListGroup } from 'react-bootstrap';
import { storesContext } from '../../stores/storesContext';
import BlockMap from './BlockMap';

const BlockInfoCard = ({ monitoringBlock, headerActions }) => {
  const userStore = useContext(storesContext);
  const propertiesStore = userStore.propertiesStore;
  const alcmStore = userStore.alcmStore;

  const mwStations = alcmStore.stations;

  const selectedBlockProperty = useMemo(
    () =>
      propertiesStore.properties.find(
        (p) => p.id === monitoringBlock?.property_id
      ),
    [propertiesStore.properties, monitoringBlock]
  );

  const blockStation = useMemo(
    () => mwStations.find((s) => s.Station_ID === monitoringBlock?.station_id),
    [mwStations, monitoringBlock]
  );

  return (
    <Card className='shadow-sm'>
      <Card.Header className='d-flex justify-content-between'>
        <div>
          <h5 className='mb-0'>{monitoringBlock.block_id}</h5>
        </div>
        {headerActions && <div className='d-flex'>{headerActions}</div>}
      </Card.Header>
      <ListGroup variant='flush'>
        <ListGroup.Item className='d-flex justify-content-between'>
          <span className='font-weight-bold text-muted'>Block ID</span>
          <span>{monitoringBlock.block_id}</span>
        </ListGroup.Item>
        <ListGroup.Item className='d-flex justify-content-between'>
          <span className='font-weight-bold text-muted'>Property</span>
          <span>
            {selectedBlockProperty
              ? `${selectedBlockProperty.name} (${selectedBlockProperty.identifier})`
              : '-'}
          </span>
        </ListGroup.Item>
        <ListGroup.Item className='d-flex justify-content-between'>
          <span className='font-weight-bold text-muted'>Station ID</span>
          <span>
            {blockStation
              ? `${blockStation.Logger_Name} (${blockStation.Station_ID})`
              : monitoringBlock.station_id}
          </span>
        </ListGroup.Item>
        <ListGroup.Item className='d-flex justify-content-between'>
          <span className='font-weight-bold text-muted'>Variety</span>
          <span>{monitoringBlock.variety || '-'}</span>
        </ListGroup.Item>
        <ListGroup.Item className='d-flex justify-content-between'>
          <span className='font-weight-bold text-muted'>Rootstock</span>
          <span>{monitoringBlock.rootstock || '-'}</span>
        </ListGroup.Item>
        <ListGroup.Item className='d-flex justify-content-between'>
          <span className='font-weight-bold text-muted'>
            G2 Trap Catch Peak
          </span>
          <span>
            {monitoringBlock.g2_trap_catch_peak_date
              ? moment(monitoringBlock.g2_trap_catch_peak_date).format(
                  'DD/MM/YYYY'
                )
              : '-'}
          </span>
        </ListGroup.Item>
        <ListGroup.Item className='d-flex justify-content-between'>
          <span className='font-weight-bold text-muted'>
            G2 Egg Monitoring Peak
          </span>
          <span>
            {monitoringBlock.g2_egg_peak_date
              ? moment(monitoringBlock.g2_egg_peak_date).format('DD/MM/YYYY')
              : '-'}
          </span>
        </ListGroup.Item>
      </ListGroup>
      {monitoringBlock.geom && (
        <Card.Body className='p-0' style={{ height: '300px' }}>
          <BlockMap geom={monitoringBlock.geom} />
        </Card.Body>
      )}
    </Card>
  );
};

export default observer(BlockInfoCard);

